import { GetMosaicColorsList } from "@/views/productColors/api";
import { GetMosaicMaterialsList } from "@/views/productMaterials/api";
import { GetMosaicSpecificationsList } from "@/views/productSpecifications/api";
import { GetMosaicStylesList } from "@/views/productStyles/api";
import { GetMosaicTechniquesList } from "@/views/productTechniques/api";
import { GetMosaicSeriesList } from "@/views/productSeries/api";
import { GetMosaicHeightsList } from "@/views/productHeights/api";
export default {
  data() {
    return {
      colorsOptions: [],
      materialsOptions: [],
      specificationsOptions: [],
      stylesOptions: [],
      techniquesOptions: [],
      seriesOptions: [],
      heightsOptions: [],
    };
  },
  methods: {
    initOptions() {
      let params = {
        disabled: false,
      };
      GetMosaicColorsList(params).then((res) => {
        this.colorsOptions = res.data.content || [];
      });
      GetMosaicMaterialsList(params).then((res) => {
        this.materialsOptions = res.data.content || [];
      });
      GetMosaicSpecificationsList(params).then((res) => {
        this.specificationsOptions = res.data.content || [];
      });
      GetMosaicStylesList(params).then((res) => {
        this.stylesOptions = res.data.content || [];
      });
      GetMosaicTechniquesList(params).then((res) => {
        this.techniquesOptions = res.data.content || [];
      });
      GetMosaicSeriesList(params).then((res) => {
        this.seriesOptions = res.data.content || [];
      });
      GetMosaicHeightsList(params).then((res) => {
        this.heightsOptions = res.data.content || [];
      });
    },
  },
};
